module.exports = __webpack_public_path__ + "static/media/Litwick_gaussian2.64c9371f.png";